import { z } from 'zod';
/**
 * `live` — процесс жив (для Docker healthcheck и restart policy).
 * `ready` — приложение может обслуживать запросы; `degraded` означает,
 * что часть подсистем недоступна, но каталог всё ещё отдаётся (demo-режим).
 */
export const healthStatusSchema = z.enum(['ok', 'degraded', 'error']);
export const healthLiveResponseSchema = z.object({
    status: z.literal('ok'),
    uptimeSeconds: z.number().nonnegative(),
    version: z.string(),
});
export const componentHealthSchema = z.object({
    /** Стабильное имя подсистемы: `catalog`, `tmdb`, `plugins`, `torrserver`, `jackett`. */
    name: z.string(),
    status: healthStatusSchema,
    /** Включена ли подсистема конфигурацией. */
    enabled: z.boolean(),
    /** Безопасное объяснение статуса. Не содержит секретов и upstream URL. */
    detail: z.string().optional(),
});
export const healthReadyResponseSchema = z.object({
    status: healthStatusSchema,
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
    /** Режим каталога: реальный TMDB-шлюз или встроенный demo-каталог. */
    catalogMode: z.enum(['tmdb', 'demo']),
    components: z.array(componentHealthSchema),
});
//# sourceMappingURL=health.js.map